"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBreakDocumentElement = void 0;
const react_1 = __importDefault(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const type = "Page Break";
exports.PageBreakDocumentElement = {
    type,
    sideBarComponent: () => react_1.default.createElement("div", null, " Components"),
    documentComponent: () => (react_1.default.createElement("div", { className: "break-after-page", style: { margin: "30px 0" } },
        react_1.default.createElement("hr", null))),
    propertiesComponent: () => react_1.default.createElement("div", null, "Properties Components"),
    construct: (_id, page) => {
        return {
            _id,
            type,
            page,
            extra_attributes: {
                edit_type: "block",
            },
        };
    },
    sidebarBtnElement: {
        icon: pro_light_svg_icons_1.faScissors,
        label: "Page Break",
    },
};
